<template>
  <SectionContainer :colors="colors" :background-variant="backgroundVariant" class="w-full"
  >
    <!-- Content -->
    <div
        v-motion
        :initial="{ opacity: 0, y: 50 }"
        :visible="{ opacity: 1, y: 0 }"
        :transition="{ duration: 1.5, ease: 'easeOut' }"
        class="relative z-10 w-full px-5 md:px-10 py-10 items-center justify-center flex flex-col"
    >
      <h3 class="text-center text-xl md:text-2xl font-bold text-[var(--text-primary)] mb-6">
        Find us on Social Media
      </h3>
      <div class="flex space-x-6">
        <button v-if="props.facebook" @click="gotoSocial('facebook')" class="text-blue-600 cursor-pointer hover:text-blue-800 transition">
          <Facebook class="w-5 h-5"/>
        </button>
        <button v-if="props.X" @click="gotoSocial('X')" class="text-gray-800 cursor-pointer hover:text-blue-600 transition">
          <X class="w-5 h-5"/>
        </button>
        <button v-if="props.instagram" @click="gotoSocial('instagram')" class="text-pink-500 cursor-pointer hover:text-pink-700 transition">
          <Instagram class="w-5 h-5"/>
        </button>
        <button v-if="props.youtube" @click="gotoSocial('youtube')" class="text-red-600 cursor-pointer hover:text-red-800 transition">
          <Youtube class="w-5 h-5"/>
        </button>
        <button v-if="props.linkedIn" @click="gotoSocial('linkedIn')" class="text-blue-700 cursor-pointer hover:text-blue-900 transition">
          <Linkedin class="w-5 h-5"/>
        </button>
        <button v-if="props.tiktok" @click="gotoSocial('tiktok')" class="text-black cursor-pointer hover:text-gray-700 transition">
          <Tiktok class="w-5 h-5"/>
        </button>
        <button v-if="props.pinterest" @click="gotoSocial('pinterest')" class="text-red-500 cursor-pointer hover:text-red-700 transition">
          <Pinterest class="w-5 h-5"/>
        </button>
      </div>
      <slot></slot>
    </div>
  </SectionContainer>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import WebButton from "@/components/WebButton.vue";
import SectionContainer from "@/components/SectionContainer.vue";
import {Facebook, Instagram, X, Youtube, Linkedin, Tiktok, Pinterest} from "@iconoir/vue";

const router = useRouter();

const props = defineProps({
  facebook: String,
  instagram: String,
  X: String,
  youtube: String,
  linkedIn: String,
  pinterest: String,
  tiktok: String,
  backgroundVariant: { type: Number, default: 1 }, // Alternating backgrounds
  colors: { type: Object, required: true } // Theme colors
});

// CSS variables for theming
const cssVars = computed(() => ({
  "--bg-light-variant-1": "#ffffff",
  "--bg-light-variant-2": props.colors.lightest,
  "--bg-dark-variant-1": props.colors.dark,
  "--bg-dark-variant-2": props.colors.darkest,
  "--text-primary": props.colors.textPrimary || "#333",
  "--text-secondary": props.colors.textSecondary || "#666"
}));

// Dynamically compute background class
const computedBackgroundClass = computed(() =>
    props.backgroundVariant === 1
        ? "bg-[var(--bg-light-variant-1)] dark2:bg-[var(--bg-dark-variant-1)]"
        : "bg-[var(--bg-light-variant-2)] dark2:bg-[var(--bg-dark-variant-2)]"
);

// Store navbar height reactively
const navHeight = ref(0);


onMounted(() => {
  const navbar = document.querySelector("nav");
  if (navbar) {
    navHeight.value = navbar.offsetHeight;
  }
});

// Open social media in new tab
const gotoSocial = (platform) => {
  let url = '#';
  if (platform === 'facebook' && props.facebook) url = props.facebook;
  else if (platform === 'instagram' && props.instagram) url = props.instagram;
  else if (platform === 'X' && props.X) url = props.X;
  else if (platform === 'youtube' && props.youtube) url = props.youtube;
  else if (platform === 'linkedIn' && props.linkedIn) url = props.linkedIn;
  else if (platform === 'pinterest' && props.pinterest) url = props.pinterest;
  else if (platform === 'tiktok' && props.tiktok) url = props.tiktok;

  if (url && url !== '#') {
    window.open(url, '_blank', 'noopener');
  }
};


</script>

<style scoped>
/* Smooth transition for background */
.transition-colors {
  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
}
</style>
